import ADD_UNIT from "cc-frontend/lib/actions/course/calendar/ADD_UNIT"
import COURSE_DATE_SAVE_AS_TEMPLATE from "cc-frontend/lib/actions/course/calendar/COURSE_DATE_SAVE_AS_TEMPLATE"
import COURSE_DATE_TEMPLATE_TOGGLE from "cc-frontend/lib/actions/course/calendar/COURSE_DATE_TEMPLATE_TOGGLE"
import COURSE_ROTATION_SET_TEMPLATE_ID from "cc-frontend/lib/actions/course/calendar/COURSE_ROTATION_SET_TEMPLATE_ID"
import DELETE_UNIT from "cc-frontend/lib/actions/course/calendar/DELETE_UNIT"
import MOVE_LESSON_TO_DATE from "cc-frontend/lib/actions/course/calendar/MOVE_LESSON_TO_DATE"
import MOVE_LESSON_TO_DATE_ON_DIFFERENT_COURSE from "cc-frontend/lib/actions/course/calendar/MOVE_LESSON_TO_DATE_ON_DIFFERENT_COURSE"
import MOVE_UNIT from "cc-frontend/lib/actions/course/calendar/MOVE_UNIT"
import RESIZE_UNIT from "cc-frontend/lib/actions/course/calendar/RESIZE_UNIT"

let patches = {
  MOVE_UNIT: MOVE_UNIT,
  MOVE_LESSON_TO_DATE: MOVE_LESSON_TO_DATE,
  MOVE_LESSON_TO_DATE_ON_DIFFERENT_COURSE: MOVE_LESSON_TO_DATE_ON_DIFFERENT_COURSE,
  RESIZE_UNIT: RESIZE_UNIT,
  DELETE_UNIT: DELETE_UNIT,
  ADD_UNIT: ADD_UNIT,
  COURSE_DATE_SAVE_AS_TEMPLATE: COURSE_DATE_SAVE_AS_TEMPLATE,
  COURSE_ROTATION_SET_TEMPLATE_ID: COURSE_ROTATION_SET_TEMPLATE_ID,
  COURSE_DATE_TEMPLATE_TOGGLE: COURSE_DATE_TEMPLATE_TOGGLE,
}

export default patches
